export function SideRail({ jumpHref, jumpLabel }: { jumpHref?: string; jumpLabel?: string }) {
  return (
    <div className="pointer-events-none fixed bottom-8 right-4 z-40 hidden flex-col items-center gap-6 lg:flex">
      {jumpHref && jumpLabel && (
        <a
          href={jumpHref}
          className="pointer-events-auto text-[10px] uppercase tracking-[0.35em] text-foreground/70 transition-colors hover:text-primary"
          style={{ writingMode: "vertical-rl" }}
        >
          {jumpLabel}
        </a>
      )}
      <span className="h-16 w-px bg-primary/50" />
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="pointer-events-auto text-[10px] uppercase tracking-[0.35em] text-foreground/70 transition-colors hover:text-primary"
        style={{ writingMode: "vertical-rl" }}
      >
        Back to top
      </button>
    </div>
  );
}
